<div>
  <b>Project Manager</b>
  <br/>
  <dw-autocomplete-readonly #Title [useServerSearch]="true" [lookupId]="LookupId" [(ngModel)]="selectedId"></dw-autocomplete-readonly>
</div>
